"use strict";

var config = require("app/util/config/config");

// Só em staging: o cookie aponta para o ambiente de um PR, que a config de build não conhece.
function betaURL() {
  if (config.env === "staging" && typeof window !== "undefined" && window.getCookie) {
    var cookieBetaURL = window.getCookie("BETA_URL");

    if (cookieBetaURL) {
      return cookieBetaURL;
    }
  }

  return config.app.betaURL;
}

module.exports = betaURL;



// WEBPACK FOOTER //
// ./app/util/config/beta-url.js